import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import user from './user'
import getters from './getters'


const state={
  // 显示index
  table:1,
  Log:1,
  data:{
    type:1,
    search:'',
  },
  User:{

  },
  zhenshi:{

  },
  usnameid:2,
  Url:'http://bgsxqy.com/',
  // Url:'http://192.168.50.46/',
}

const mutations={
  DataTable(state,Table){
    state.table = Table;
  },
  Login(state,Log){
    state.Log = Log;
  },
  //搜索
  getSosuo(state,data){
    state.centent = data;
    // console.log(data)
  },
  getgeID(state,data){
    state.usnameid = data;
    console.log(data)
  },
  getUser(state,data){
    state.User = data;
  }
}

export default new Vuex.Store({
  getters,
  state,
  mutations,
  modules:{
    user
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js